<button type="button" mat-stroked-button (click)="handleToggleFilter($event)">
  Filtrar Contenido
</button>

@for (filter of data$ | async; track filter.key) {
<mat-chip-row
  class="mx-2"
  [matTooltip]="filter.tooltip ?? ''"
  (removed)="handleRemoveFilter(filter)"
>
  {{ filter.label }}

  @if (!filter.isFixed) {
  <button matChipRemove [attr.aria-label]="filter.ariaLabel">
    <mat-icon>close</mat-icon>
  </button>
  }
</mat-chip-row>
}
